import { render, staticRenderFns } from "./Fundos.vue?vue&type=template&id=44495353"
import script from "./Fundos.vue?vue&type=script&lang=js"
export * from "./Fundos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports